var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{staticClass:"pie-chart-card h-full"},[_c('vue-apex-charts',{ref:"apexChart",staticClass:"w-full h-full flex justify-center items-center",staticStyle:{"padding":"0 7px"},attrs:{"height":"350px","type":"donut","options":_vm.options,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }